import React, { useState, useMemo, useRef } from 'react';
import { ConsolePage } from './ConsolePage';
import { EntrancePage } from './EntrancePage';
import { Session } from '../agent/session';

export const MainPage: React.FC = () => {
  const initialSession = useMemo(() => (new Session('')), []); // Created once
  const sessionRef = useRef<Session>(initialSession);

  const [currentPage, setCurrentPage] = useState<'entrance' | 'console'>('entrance');

  const handleConnect = () => {
    // Initialize connection if needed
    setCurrentPage('console');
  };

  return currentPage === 'entrance' ? (
    <EntrancePage sessionRef={sessionRef} onConnect={handleConnect} />
  ) : (
    <ConsolePage sessionRef={sessionRef} />
  );
};

export default MainPage;
